<template>
  <div class="card card-custom" v-if="client">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de modification d'un client</h2>
          <FormClient v-model="client" @submit="submit"></FormClient>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormClient from "@/components/admin/client/forms/formClient.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "editClient",
  components: {
    FormClient,
  },
  data: () => ({
    client: null,
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients" },
      { title: "Gestion des comptes clients", route: "gestionClients" },
      { title: "Modifier un client" },
    ]);

    var clientId = this.$route.params.id;
    var clientData = this.$route.params.client;

    if (clientData) {
      this.populateClientForm(clientData);

    } else {
      Api.get(`/clients/${clientId}`).then((client) => {
        this.populateClientForm(client.data);
      });
    }
  },
  methods: {
    submit: async function() {
      
      try {
          await Api.patch('clients',this.client.id, {
          name: this.client.name,
          email: this.client.email,
          comment: this.client.comment,
          userRights: this.client.userRights.map(ur => ur["@id"]),
        });
        Swal.fire({
          title: "",
          text: "Le client a été modifié.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: "gestionClients", query: {
                  selected: "tab-clients",
                },})
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la modification du client",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }
    },

    populateClientForm(client) {
      this.client = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines
        ...client,
      };
    },
  },
};
</script>
